import { getI18n } from '@/core/i18n';

const i18n = getI18n();

export default [
  {
    title: i18n.t('misc.telemetry'),
    route: { name: 'telemetry$telemetry' },
    icon: 'icon_telemetry',
  },
  {
    title: i18n.t('common.service_center'),
    icon: 'service',
    children: [
      {
        title: i18n.t('misc.diagnostics'),
        route: { name: 'service-diagnostics$diagnostics' },
      },
    ],
  },
  {
    title: i18n.t('common.settings'),
    icon: 'gear',
    children: [
      {
        title: i18n.t('common.legal_entities'),
        route: { name: 'entities$list' },
        init_key: 'entities',
      },
      {
        title: i18n.t('common.virtual_terminals'),
        route: { name: 'terminals$list' },
        init_key: 'terminals',
      },
      {
        title: i18n.t('common.employees'),
        route: { name: 'employees$employees' },
      },
      {
        title: i18n.t('misc.user_profile'),
        route: { name: 'profile$profile' },
      },
    ],
  },
];

